import React from 'react'

import { useIcaewModals } from '@/components/modals/IcaewModals/hooks/useIcaewModals'

const IcaewModalSteps: React.FC = () => {
  const { currentStepNumber, numSteps, shouldShowStepIndicators } =
    useIcaewModals()

  if (!shouldShowStepIndicators) {
    return null
  }

  return (
    <span className="text-dim text-body-base ml-2 inline-block font-normal">
      ({currentStepNumber}/{numSteps})
    </span>
  )
}

export default IcaewModalSteps
